<div class="table-layout">
  <ion-grid class="p-0 h100vh">
    <ion-row class="p-0 mb-5" *ngIf="gridData.tabsData.length!=0">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
        <div class="borderbottomForTab">
          <mat-tab-group [selectedIndex]="selectedTypeTabIndex" (selectedTabChange)="tabTypeChanged($event)">
            <mat-tab *ngFor="let item of gridData.tabsData">
              <ng-template mat-tab-label>
                <span style="display: contents;" *ngIf="item.label != 'Change Password'">
                  <span class="material-icons mr-10">{{item.icons}}</span>
                  {{item.label}} ({{item.totalCount}})
                </span>
                <span style="display: contents;" *ngIf="item.label == 'Change Password'">
                  <span class="material-icons mr-10">{{item.icons}}</span>
                  {{item.label}}
                </span>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" *ngIf="gridData.countTabs.length != 0">
        <div class="cardBoxList">
          <div *ngFor="let item of gridData.countTabs; let isLast = last" class="cardBoxGraph">
            <div class="display-space-between">
              <div>
                <label class="formLabelSemiBoldfs14 fs-12ForMobileView">{{ item.tabsName }}</label>
              </div>
              <div>
                <label class="font_semibold fs-18 fs-12ForMobileView" [style.color]="item.color">
                  {{ item.displayCount |
                  number }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="p-0 mb-10 ion-justify-content-between ion-align-items-center">
      <ion-col size>
        <div class="verticle-center">
          <img *ngIf="gridData.showBackBtn" src="././assets/icon/backArrow.svg" class="cp mr-10" (click)="backBtn()" />
          <ion-label class="font_bold fs-16 fs_14ForMobile black_color fs_14ForMobile" *ngIf="gridData?.showTitle">{{TableName}} ({{gridData.totalCount}})</ion-label>
          <ion-label class="font_bold black_color" *ngIf="gridData?.showBreadCrumbs">
            <span class="cp fs_14ForMobile">Configuration</span>
            &nbsp;>&nbsp;
            <span class="cp">UA/UC Configuration</span>
            &nbsp;>&nbsp;
            <span [style.color]="buttonColorName">234</span>
          </ion-label>
        </div>
      </ion-col>
      <ion-col size="auto">
        <div class="emp-master-eia-btns">
          <button *ngIf="gridData?.showExportBtn" type="button" class="exportToExcel_btn fs-14 fs_12ForMobile font_medium">
            <span class="d-inline-flex ion-align-items-center" (click)="exportReport()">
              <img class="mr-5" src="././assets/icon/exportIcon.svg" />
              Export
            </span>
          </button>
          <button *ngIf="gridData?.showImportBtn" type="button" class="import_btn fs-14 fs_12ForMobile">
            <span class="d-inline-flex ion-align-items-center" (click)="importReport()">
              <img class="mr-5" src="././assets/icon/importIcon.svg" />
              Import
            </span>
          </button>
          <button *ngIf="gridData?.showAddBtn" type="button" class="add_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" (click)="addRecord()">+ Add New</button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="gridData.tabsMainData.length!=0">
      <ion-col size="12" class="p-0 mt-10 mb-10">
        <mat-tab-group class="whiteBox demo-tab-group" [selectedIndex]="selectedStatusTabIndex" (selectedTabChange)="tabStatusChanged($event)">
          <mat-tab *ngFor="let item of gridData.tabsMainData" label="{{item.label}} ({{item.totalCount}})"></mat-tab>
        </mat-tab-group>
      </ion-col>
    </ion-row>

    <!-- nested Tabs -->
    <div class="d-flex" *ngIf="(gridData?.showBackBtn && gridData?.showAuditLog) || gridData?.showAuditLog">
      <img *ngIf="gridData.showBackBtn && gridData.showAuditLog" src="././assets/icon/forgetback.png" class="cp" (click)="backBtn()" />
      <label *ngIf="gridData.showAuditLog" class="font_medium fs-16 fs_14ForMobile ml-10 mt-5">
        {{TableName}}
        <span class="red-cl" *ngIf="observationNumber!=null">&nbsp;>&nbsp;{{observationNumber}}</span>
      </label>
    </div>

    <ion-row class="p-0 mb-10 align-center justify-between">
      <!-- Left Section: Audit Log + Buttons + Search -->
      <ion-col size="12" size-md="10" class="verticle-center">
        <div class="emp-master-filter-btns mb-10 d-flex align-center">
          <!-- Audit Log Label -->
          <ion-label *ngIf="gridData.showAuditLog" class="font_bold mr-10">
            {{auditLogName}}
          </ion-label>

          <!-- Restore Button -->
          <button *ngIf="gridData.showRestoreBtn && (mulipleSelect.length>0 || selectAllCheckbox)" class="import_btn link fs-14 fs_12ForMobile font_semibold verticle-center mr-10" (click)="restoreData()">
            <span class="material-icons mr-5">settings_backup_restore</span>
            Restore
          </button>

          <!-- Delete Button -->
          <button *ngIf="(gridData.showPermantDeleteBtn || gridData.showDeleteBtn) && isPerDeleteFlag && (mulipleSelect.length>0 || selectAllCheckbox)" class="delete_btn fs-14 fs_12ForMobile font_semibold verticle-center mr-10" (click)="deleteMultipleRecords()">Delete</button>

          <!-- Search Field -->
          <mat-form-field *ngIf="gridData.showSearchBar" class="mat-height40 mat-input-style m-0">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchText" (input)="onSearch()" />
          </mat-form-field>
        </div>
      </ion-col>

      <!-- Right Section: Refresh Icon -->
      <!-- Right Section: Refresh Icon -->
      <ion-col size="auto" class="verticle-center refresh-col">
        <span class="ml-5 fs-20 material-icons btn-reset" style="cursor:pointer;" [class.clicked]="isClicked" (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">refresh</span>
      </ion-col>
    </ion-row>

    <mat-sidenav-container style="height: 100%;">
      <!-- Main Content with AG Grid -->
      <mat-sidenav-content>
        <ag-grid-angular style="width: 100%; height: 600px;" class="ag-theme-quartz" [rowData]="agRowData" [columnDefs]="agColumnDefs" [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)" (cellClicked)="onRowClickedForEmployee($event)" (firstDataRendered)="onFirstDataRendered($event)" [pagination]="pagination" [paginationPageSize]="paginationPageSize" (paginationChanged)="onPaginationChanged()" [paginationPageSizeSelector]="paginationPageSizeSelector" [detailRowAutoHeight]="detailRowAutoHeight" (selectionChanged)="onSelectionChanged()" rowSelection="multiple" [localeText]="{ noRowsToShow: 'No Data Found' }"></ag-grid-angular>
      </mat-sidenav-content>
    </mat-sidenav-container>

    <div class="tableBox mt-10">
      <ion-row class="p-0"></ion-row>
      <ion-row class="bg-white display-center" *ngIf="renderData.length === 0">
        <div class="pt-50 pb-40 fs-16 fs_14ForMobile font_medium cl-black">No Data Available</div>
      </ion-row>
    </div>

    <div class="clear100"></div>
    <div class="clear20"></div>
  </ion-grid>
</div>
